/**
 * UpdatingOverlay - Full-screen overlay shown during auto-update.
 *
 * Displayed briefly while the app clears caches and reloads.
 * Provides visual feedback that an update is in progress.
 */
import { useUpdateStore } from '../store/updateStore';
import TypingIndicator from '../atoms/TypingIndicator';

export default function UpdatingOverlay() {
  const { showUpdatingOverlay, latestVersion } = useUpdateStore();

  if (!showUpdatingOverlay) return null;

  return (
    <div className="fixed inset-0 z-[200] flex flex-col items-center justify-center bg-background">
      {/* Spinner */}
      <div className="relative mb-6">
        <div className="w-16 h-16 rounded-full border-4 border-surface animate-spin border-t-primary" />
      </div>

      {/* Text */}
      <h2 className="text-xl font-semibold text-text mb-2">
        Updating Momento
      </h2>
      <p className="text-text-secondary text-sm">
        {latestVersion ? `Installing v${latestVersion}...` : 'Please wait...'}
      </p>

      {/* Progress dots animation */}
      <TypingIndicator bubble={false} dotClassName="bg-primary" className="mt-4" />
    </div>
  );
}
